export const VAT_LABEL=[
    {value: null, label: "VAT chưa xác định", shortLabel: "CXĐ"},
    {value:0, label: "VAT 0%", shortLabel: "0%"},
    {value:5, label: "VAT 5%", shortLabel: "5%"},
    {value:8, label: "VAT 8%", shortLabel: "8%"},
    {value:10, label: "VAT 10%", shortLabel: "10%"},
    {value:-1, label: 'VAT không chịu thuế', shortLabel: "KCT"},
    {value:-2, label: 'VAT không kê khai', shortLabel: "KKK"},
]